module.exports = __webpack_public_path__ + "media/images/products/category/5-75bff230d4e8646414a75aab097f7355.jpg";